import { render, staticRenderFns } from "./seeyousoon.vue?vue&type=template&id=bdb61c34&scoped=true"
import script from "./seeyousoon.vue?vue&type=script&lang=js"
export * from "./seeyousoon.vue?vue&type=script&lang=js"
import style0 from "./seeyousoon.vue?vue&type=style&index=0&id=bdb61c34&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdb61c34",
  null
  
)

export default component.exports